// Grocery industry tokens. Forest-green primary, orange-red sale accent and a
// yellow highlight, Jost headlines over Poppins UI, tight radii.
import { baseTokens } from '../_base/tokens.js';

export const groceryTokens = {
  ...baseTokens,
  token: {
    ...baseTokens.token,
    colorPrimary: '#347758',
    colorInfo: '#347758',
    colorLink: '#347758',
    colorPrimaryHover: '#3f8a67',
    colorLinkHover: '#27573e',
    colorPrimaryActive: '#27573e',
    colorWarning: '#f26222',
    borderRadius: 6,
    fontFamily:
      "'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    ...baseTokens.components,
    Card: { borderRadiusLG: 8 },
    Button: { borderRadius: 6, fontWeight: 500 },
  },
};
